<div class="d-flex justify-content-between pageTitleParent pb-3 mw-100">
  <div class="text-center">
    <h2 *ngIf="!editMode" class=" float-md-left pageTitle largerFontSize2">Create change order</h2>
    <h2 *ngIf="editMode" class=" float-md-left pageTitle largerFontSize2">Edit change order</h2>
  </div>
</div>

<div>
  <span class="d-inline-block align-middle msg-text">
    This form must be completed for changes in scope resulting in a change order to an existing statement of work
    (“SOW”). A change order is appropriate when there is an extension of time, addition of resources, increase to a
    fixed fee amount, or other similar changes pursuant to the same services associated with an active engagement under
    an existing executed SOW. Note: An addition of resources includes third parties (including INDUS, third party contractors, and GTIL member
    firms).
  </span>
</div>

<div class="bg-white pl-0 pr-0 pb-3">
  <div class="row">
    <div class="col-xl-6 col-md-6 pt-3">
      <label><span class="label">Select existing client </span> <span class="label mandatory">*</span></label>
      <div class="selectdiv">
        <select id="drpselectClientId" name="selectClientId" class="dropdown rounded-0" (change)="onClientsChange()"
          [(ngModel)]="clientId" [disabled]="editMode==true">
          <option [ngValue]="-1">Select client</option>
          <option *ngFor="let clientInfo of clientkeyValueList" [ngValue]=clientInfo.key>
            {{clientInfo.value}}
          </option>
        </select>
      </div>
      <div class="form-control-feedback error-color" *ngIf="!isclientSelected">
        <span>Client is a required field.</span>
      </div>
    </div>
    <div class="col-xl-6 col-md-6 pr-0 pt-3">
      <label><span class="label">Select existing engagement </span> <span class="label mandatory">*</span></label>
      <div class="selectdiv ">
        <select id="drpselectEngagementId" name="selectEngagementId" class="dropdown rounded-0"
          [(ngModel)]="engagementId" (change)="onEngagementsChange()" [disabled]="editMode==true">
          <option [ngValue]="-1">Select engagement</option>
          <option *ngFor="let engagementInfo of engagementkeyValueList" [ngValue]=engagementInfo.key>
            {{engagementInfo.value}}
          </option>
        </select>
      </div>
      <div class="form-control-feedback error-color" *ngIf="!isEngagementSelected">
        <span>Engagement is a required field.</span>
      </div>
    </div>
  </div>
</div>
<div class="row m-0 mt-2">
  <div id="engagementDetailHeaderDiv" class="col-md-12 m-0 pl-0">
    <h6 class="form-heading-text">Engagement details</h6>

    <div class="row m-0 bg-light">
      <div class="col-md-12 pt-2 pl-3 pb-3">
        <div class="mt-1">Selected engagement: </div>
        <div>
          <a class="eng-pointer-cursor" [routerLink]="['/EngagementDetail/',engagementId]"
            target="_blank">{{engagementName}}</a>
        </div>
        <br>
        <div>Previously approved change order(s):</div>
        <div style="list-style-type: none;">
          <div *ngFor="let order of changeOrderHistoryList">
            <div *ngIf="order.status == 'Approved'">
              <a [routerLink]="['/Review/',order.workspaceId]" target="_blank">{{ order.changeOrderName }}</a> -
              Approved {{
              order.lastModifiedDate | date: 'MM/dd/yyyy'
              }}
            </div>
          </div>
        </div>
        <br>
        <div>Pending change order(s):</div>
        <div style="list-style-type: none;">
          <div *ngFor="let order of changeOrderHistoryList">
            <div *ngIf="order.status !== 'Approved'">
              <a *ngIf="order.status === 'Draft'" class="cursor-pointer"
                [routerLink]="['/Interviews/',order.workspaceId]" target="_blank">{{
                order.changeOrderName }}</a>
              <a *ngIf="order.status !== 'Draft'" class="cursor-pointer" [routerLink]="['/Review/',order.workspaceId]"
                target="_blank">{{
                order.changeOrderName }}</a> -
              Created by
              {{order.createdBy.split('.')[1].split('@')[0]}}, {{order.createdBy.split('.')[0]}} on {{
              order.lastModifiedDate | date: 'MM/dd/yyyy'
              }} - {{order.status}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row m-0 mt-4">
  <div class="col-md-12 m-0 pl-0">
    <h6 class="form-heading-text">Assignments</h6>
    <span class="d-inline-block align-middle msg-text">
      Select an assignment associated with the change order / work extension. A new assignment code will be generated.
    </span>
    <div class="row m-0 mt-3">
      <div class="col-md-12 p-0">
        <div class="bg-white" [class.assignment-radio-container]="arrEngagementAssignment.length == 0"
              [class.assignment-radio-container-scroll]="isVisibledefaultAssignmentDiv == false">
            <div *ngFor="let item of changeOrderAssignments; let isLast = last"
              [class.seperator]="!isLast && !isVisibledefaultAssignmentDiv && arrEngagementAssignment.length == 0"
              [class.pb-3]="!isVisibledefaultAssignmentDiv && arrEngagementAssignment.length == 0"
              [hidden]="(isVisibledefaultAssignmentDiv || arrEngagementAssignment.length > 0) && selectedAssignmentCodeId != item.assignmentCodeId" class="pt-3">
              <label class="custom-radio mb-0">
                {{ item.assignmentName }} <span *ngIf="item.solutionCode">({{item.solutionCode}})</span>
                <input type="radio" name="assignmentSelection" [value]="item.assignmentCodeId"
                  [checked]="selectedAssignmentCodeId == item.assignmentCodeId"
                  (change)="onChangeOrderAssinmentChange(item)" />
                <span class="checkmark"></span>
              </label>

              <!-- Assignment details shown right below selected radio button -->
              <div *ngIf="isVisibledefaultAssignmentDiv && selectedAssignmentCodeId == item.assignmentCodeId"
                class="mt-3">
                <div
                  *ngIf="(defaultEngAssignment.opportunityServiceId == '' || defaultEngAssignment.opportunityServiceId == undefined)">
                  Opportunity: <span class="font-weight-bold">—</span>
                </div>
                <div
                  *ngIf="(defaultEngAssignment.opportunityServiceId != '' && defaultEngAssignment.opportunityServiceId != undefined)">
                  Opportunity: <span class="font-weight-bold">{{defaultEngAssignment.opportunityName}}
                    ({{defaultEngAssignment.opportunityServiceId}})</span>
                </div>
                <div class="col-md-12 bg-white pl-0 pb-3">
                  <div class="row m-0">
                    <div class="col-xl-3 col-md-6 pr-2 pt-3 pl-0">
                      <label><span class="label">Assignment name </span> <span class="label mandatory">*</span></label>
                      <input id="txtAssignmentName" name="assignmentName" class="input-height form-control rounded-0 "
                        type="text" maxlength="40" placeholder="Assignment name"
                        [(ngModel)]="defaultEngAssignment.assignmentName"
                        (change)="invalidCharacterDetectionAssignmentName()"
                        (keyup)="invalidCharacterDetectionAssignmentName()" autocomplete="off" autofocus>
                      <div id="EngagementNameHint" class="span-hint mt-1 mb-0" *ngIf="!(!arrControlValidation[0]?.isvalid && arrControlValidation[0]?.apply) &&
                                  !(isNewAssignmentNameDuplicate  || isAssignmentNameExistForClient) &&
                                  validAssignmentName && !(invalidvaluesAN != '' && invalidvaluesAN != null)">
                        <p>Allowable: . - _ & ' , ( )</p>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="invalidvaluesAN != '' && invalidvaluesAN != null ">
                        <p>'{{invalidvaluesAN}}' <span *ngIf="invalidvaluesAN.length === 1">is not allowed.</span><span
                            *ngIf="invalidvaluesAN.length > 1">are not allowed.</span></p>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[0]?.isvalid && arrControlValidation[0]?.apply">
                        <p>Enter assignment name</p>
                      </div>
                      <div class="error-color " *ngIf="isNewAssignmentNameDuplicate  || isAssignmentNameExistForClient">
                        <p>Duplicate assignment name </p>
                      </div>
                      <div class="form-control-feedback error-color" *ngIf="!validAssignmentName">
                        <p>Invalid Assignment Name </p>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Solution code </span> <span class="label mandatory">*</span></label>
                      <div class="selectdiv ">

                        <select id="drpsolutionCodeId" name="selectedsolutionCode" class="dropdown rounded-0"
                          [disabled]="isDisableSolutionCode" [(ngModel)]="defaultEngAssignment.solutionCodeId">
                          <option value="null" disabled hidden>Select solution code</option>
                          <option *ngFor="let solutionCode of defaultEngAssignment.solutionCodeListData"
                            [value]=solutionCode?.childSolutionCodeId>
                            {{solutionCode.solutionCode}}-{{solutionCode.solutionCodeDescription}}</option>
                        </select>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[1]?.isvalid && arrControlValidation[1]?.apply">
                        <p>Select solution code</p>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">CMS PPMD </span> <span class="label mandatory">*</span></label>
                      <div class="input-group mw-100">
                        <app-people-picker class="eng-assign-people-picker" [IsPickerForAssignment]=true
                          [roleShortName]="epRoleName" [labelCtrlName]="cmslblCtrlName" [isLabelVisible]="false"
                          [InputCtrlIdIndex]="peoplepickerIndex" [PeoplePickerModel]="cmsDisplayUserName"
                          [userEmail]="cmsDisplayUserEmail" [IsValidateUserWithADGroup]="validateCMSEP">
                        </app-people-picker>

                        <div class="input-group-append input-height">
                          <button type="button" id="PPIcon_{{peoplepickerIndex}}" data-toggle="modal"
                            data-target="#modal-EP" data-keyboard="false" data-backdrop="static"
                            class="mw-100 people-picker-button text-center"
                            (click)="refreshCMSEPPopup(1,'txtPeoplePicker_')">
                            <img src="assets/images/EDP/LeftSidebar/picker.svg" alt="CMS PPMD" />
                          </button>
                        </div>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[6]?.isvalid && arrControlValidation[6]?.apply">
                        <p>Select CMS PPMD</p>
                      </div>
                      <div class="form-control-feedback error-color" *ngIf="!isvalidcmsEPPMDName">
                        <p>CMS PPMD should be valid</p>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Assignment administrator </span> <span
                          class="label mandatory">*</span></label>
                      <div class="input-group mw-100">
                        <app-people-picker class="eng-assign-people-picker" [roleShortName]="assignAdminRoleName"
                          [labelCtrlName]="assignAdminlblCtrlName" [isLabelVisible]="false"
                          [InputCtrlIdIndex]="peoplepickerIndex" [IsPickerForAssignment]=true
                          [PeoplePickerModel]="adminDisplayUserName" [userEmail]="adminDisplayUserEmail"
                          [IsValidateUserWithADGroup]="validateCMSAA">
                        </app-people-picker>

                        <div class="input-group-append input-height">
                          <button type="button" id="PPIcon_{{peoplepickerIndex}}" data-toggle="modal"
                            data-target="#modal-AssignmentAdministrator" data-keyboard="false" data-backdrop="static"
                            class="mw-100 people-picker-button text-center"
                            (click)="refreshCMSAssignmentAdminPopup(1,'txtPeoplePicker_')">
                            <img src="assets/images/EDP/LeftSidebar/picker.svg" alt="Assignment administrator" />
                          </button>
                        </div>
                      </div>
                      <div id="mandatoryMessageForAdministratorsDiv" class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[7]?.isvalid && arrControlValidation[7]?.apply">
                        <p>Select assignment administrator</p>
                      </div>

                      <div id="businessMessageForAdministratorsDiv" style="display: none;"
                        class="form-control-feedback error-color">
                        <p>CMS PPMD and AA cannot be the same.</p>
                      </div>
                      <div class="form-control-feedback error-color" *ngIf="!isvalidAassignmentAdministrator">
                        <p>Assignment administrator should be valid</p>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-xl-3 col-md-6 pr-2 pt-3 pl-0">
                      <label><span class="label">Engagement type </span> <span class="label mandatory">*</span>
                      </label>
                      <div class="selectdiv ">
                        <select id="drpengagementTypeId" name="selectedengagementType"
                          class="dropdown rounded-0 form-control" [(ngModel)]="defaultEngAssignment.engagementTypeId">
                          <option value="0" selected="selected">Select engagement type</option>
                          <option *ngFor="let EngTypeItem of engtypekeyValueList"
                            [value]=EngTypeItem.key>
                            {{EngTypeItem.value}}</option>
                        </select>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[2]?.isvalid && arrControlValidation[2]?.apply">
                        <p>Select engagement type</p>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label for="engPeriodDate">Estimated start date </label>
                      <span class="label mandatory"
                        *ngIf="defaultEngAssignment.selectedsolutionCode?.isEngagementStartDateRequired">*</span>
                      <app-calendercontrol id="EstimatedStartDate" [txtDate]="StartDateCtrlId" class="eng-period-date"
                        [(ngModel)]="defaultEngAssignment.engagementStartDate">
                      </app-calendercontrol>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[12]?.isvalid && arrControlValidation[12]?.apply">
                        <p>Enter estimated start date</p>
                      </div>
                      <div id="errormessage" class="error-color" *ngIf="DateCompareResult === 1">
                        <p>Start date cannot be after the end date</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="!isvalidESD">
                        <p>Start date should be valid</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="startDateCompareResult > 0">
                        <p>Start cannot be in the past</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color"
                        *ngIf="(yearValidationResult == 1 || yearValidationResult == 2  ) && DateCompareResult < 0">
                        <p>Start date must be within 13 months from current date</p>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label for="engPeriodDate">Estimated end date</label>
                      <span class="label mandatory"
                        *ngIf="defaultEngAssignment?.selectedsolutionCode?.isEngagementEndDateRequired">*</span>
                      <app-calendercontrol id="EstimatedEndDate" [txtDate]="EndDateCtrlId" class="eng-period-date"
                        [(ngModel)]="defaultEngAssignment.engagementEndDate">
                      </app-calendercontrol>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[13]?.isvalid && arrControlValidation[13]?.apply">
                        <p>Enter estimated end date</p>
                      </div>
                      <div id="errormessage" class="error-color" *ngIf="DateCompareResult == 0">
                        <p>Start date and end date can not be equal</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="!isvalidEED">
                        <p>End date should be valid</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color"
                        *ngIf="(yearValidationResult == 1 || yearValidationResult == 3 ) && DateCompareResult < 0">
                        <p>The end date must be within 5 years of the start date.</p>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Closest GT office</span> </label>
                      <div class="selectdiv">
                        <select id="ddClosestGTOffice" class="dropdown rounded-0 form-control"
                          [(ngModel)]="defaultEngAssignment.officeLocationCodeId">
                          <option value="0" disabled hidden>Select closest GT office</option>
                          <option *ngFor="let location of ClientLocations" [value]="location.id">
                            {{location.typeValue}}
                          </option>
                        </select>
                      </div>
                    </div>

                  </div>
                  <!-- new fieds -->
                  <div class="row m-0">
                    <div class="col-xl-3 col-md-6 pr-2 pt-3 pl-0">
                      <label><span class="label">Contingent </span> <span class="label mandatory">*</span></label>
                      <div class="selectdiv">
                        <select id="drpisContingent" name="isContingent" class="dropdown rounded-0 form-control"
                          [(ngModel)]="defaultEngAssignment.isContingent">
                          <option value="null" disabled hidden>Yes or No</option>
                          <option *ngFor="let item of contingentkeyValueList" [value]=item.key>
                            {{item.value}}
                          </option>
                        </select>
                      </div>
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[5]?.isvalid && arrControlValidation[5]?.apply">
                        <p>Select contingent</p>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Estimated net fees </span> <span class="label mandatory">*</span></label>
                      <input id="txtnetFees" name="netFees" class="input-height form-control rounded-0 " maxlength="9"
                        type="text" placeholder="$1,000,000" pattern="^[0-9]+(\.[0-9]{1,2})?$" autocomplete="off"
                        (keypress)="numberOnly($event)" [(ngModel)]="defaultEngAssignment.netFees"
                        [disabled]="isDisableForADV029">
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[4]?.isvalid && arrControlValidation[4]?.apply">
                        <p>Enter estimated net fees</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="!validNetfees">
                        <p>{{netFeesMessage}}</p>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Realization % </span> <span
                          class="label mandatory input-height">*</span></label>
                      <input id="txtrealization" name="realization" class="input-height form-control rounded-0 "
                        type="text" placeholder="00%" maxlength="3" [(ngModel)]="defaultEngAssignment.realization"
                        autocomplete="off" (keypress)="numberOnly($event)" [disabled]="isDisableForADV029">
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[3]?.isvalid && arrControlValidation[3]?.apply">
                        <p>Enter realization</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="!validRealization">
                        <p>{{RealizationMessage}}</p>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label for="EstimatedGM">Estimated gross margin % <span class="mandatory"
                          *ngIf="((defaultEngAssignment || {}).selectedsolutionCode || {}).isGrossMarginRequire==true">*</span></label>
                      <input id="txtGrossMargin" name="txtGrossMargin" class="input-height form-control rounded-0 "
                        type="text" placeholder="00%" maxlength="3" (keypress)="numberOnly($event)"
                        [(ngModel)]="defaultEngAssignment.estimatedGrossMargin" autocomplete="off"
                        [disabled]="isDisableForADV029">
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[11]?.isvalid && arrControlValidation[11]?.apply">
                        <p>Enter Estimated gross margin</p>
                      </div>
                      <div id="errormessage" class="form-control-feedback error-color" *ngIf="!validEGrossMargin">
                        <p>{{grossMarginMessage}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-xl-3 col-md-6 pr-2 pt-3 pl-0">
                      <label><span class="label">Client billing contact name </span> <span
                          class="label mandatory">*</span></label>
                      <input id="txtClientBillingName" name="clientBillingName"
                        [(ngModel)]="defaultEngAssignment.clientBillingContactName" autocomplete="off"
                        class="input-height form-control rounded-0 " maxlength="50" type="text"
                        placeholder="(Default based on client)">
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[8]?.isvalid && arrControlValidation[8]?.apply">
                        <p>Enter client billing name</p>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Client billing contact title </span> <span
                          class="label mandatory input-height">*</span></label>
                      <div class="selectdiv">
                        <select id="ddClientBillingTitle" name="clientBillingTitle"
                          class="dropdown rounded-0 form-control"
                          [(ngModel)]="defaultEngAssignment.clientBillingContactTitleId">
                          <option value="0" disabled hidden>(Default based on client)</option>
                          <option *ngFor="let contact of ClientContactTypes" [value]="contact.id">
                            {{contact.typeValue}}
                          </option>
                        </select>
                        <div class="form-control-feedback error-color"
                          *ngIf="!arrControlValidation[9]?.isvalid && arrControlValidation[09]?.apply">
                          <p>Select client billing contact title</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Client billing email </span>
                        <span class="label mandatory">*</span></label>
                      <input id="txtClientBillingEmail" name="clientBillingEmail"
                        [(ngModel)]="defaultEngAssignment.clientBillingContactEmail" autocomplete="off"
                        class="input-height form-control rounded-0 " maxlength="80" type="text"
                        placeholder="(Default based on client)" (blur)="checkSpaceChartBegin($event)">
                      <div class="form-control-feedback error-color"
                        *ngIf="!arrControlValidation[10]?.isvalid && arrControlValidation[10]?.apply">
                        <p>Enter client billing email</p>
                      </div>
                      <div class="form-control-feedback error-color" *ngIf="isInvalidClientBillingContactEmail">
                        <p>Enter valid client billing email</p>
                      </div>
                    </div>
                    <!-- Start Assignment EQCR field ------>
                    <div class="col-xl-3 col-md-6 pr-2 pt-3">
                      <label><span class="label">Assignment EQCR
                        </span></label>
                      <div class="input-group mw-100">

                        <app-people-picker class="eng-assign-people-picker" [IsPickerForAssignment]=true
                          [roleShortName]="EQCRRoleName" [labelCtrlName]="EQCRlblCtrlName" [isLabelVisible]="false"
                          [InputCtrlIdIndex]="peoplepickerIndex" [PeoplePickerModel]="defaultEngAssignment.newEQCRName"
                          [userEmail]="defaultEngAssignment.newEQCREmailId" [IsValidateUserWithADGroup]="validateEQCR">
                        </app-people-picker>

                        <div class="input-group-append input-height">
                          <button type="button" id="PPIcon_{{peoplepickerIndex}}" data-toggle="modal"
                            data-target="#modal-AssignmentEQCR" data-keyboard="false" data-backdrop="static"
                            class="mw-100 people-picker-button text-center"
                            (click)="refreshAssignmentEQCRPopup(peoplepickerIndex,'txtPeoplePicker_')">
                            <img src="assets/images/EDP/LeftSidebar/picker.svg" alt="Assignment EQCR" />
                          </button>

                        </div>

                      </div>

                      <div class="form-control-feedback error-color" *ngIf="!defaultEngAssignment.isvalidEQCR">
                        <p>Assignment EQCR should be valid</p>
                      </div>

                      <div id="businessMessageForEQCRDiv" *ngIf="!defaultEngAssignment.isValidEQCRBusinessRule"
                        class="form-control-feedback error-color">
                        <p>EQCR cannot be EPPMD or CMS PPMD or AA</p>
                      </div>
                    </div>
                    <!-- end Assignment EQCR field -->
                  </div>

                  <div class="row m-0">
                    <div class="col-xl-3 col-md-6 pr-2 pt-3 pl-0">
                      <label><span class="label">Staffing link (Dayshape) </span></label>
                      <div>
                        <input id="txtDayshapeLink" name="txtDayshapeLink" class="input-height form-control rounded-0 "
                          type="text" [(ngModel)]="defaultEngAssignment.dayShapeLink" autocomplete="off"
                          [disabled]="isMemberFirm">
                      </div>
                    </div>
                  </div>
                  <!-- end new fields -->
                  <!-- button row start -->
                  <div class="row mx-0 my-2">
                    <div class="col-xl-6 col-md-6 pr-2 pt-3">
                    </div>
                    <div class="col-xl-3 col-md-3 pr-2 pt-3">
                      <button id="btnCancelAssignment"
                        class="btn SecondaryButton w-100 text-center" type="button"
                        (click)="cancelAssignment('')">
                        Cancel
                      </button>
                    </div>
                    <div class="col-xl-3 col-md-3 pr-2 pt-3">
                      <button id="btnSaveAssignment" class="btn PrimaryButton rounded-0 w-100 input-height" type="button"
                        (click)="saveAssignment(defaultEngAssignment.assignmentName)">
                        <img src="../../../../assets/images/EDP/Engagement/save-24px.svg" alt="Save"
                          style="cursor: pointer; margin-right: 3px;">
                        Save assignment
                      </button>
                    </div>
                    <!-- button row End -->
                  </div>
                </div>
              </div>

              <!-- Readonly assignment view shown right below selected radio button -->
              <div *ngFor="let assignmentItem of arrEngagementAssignment; let i = index">
                <div *ngIf="!isVisibledefaultAssignmentDiv" class="mt-3">
                  <div class="col-md-12 bg-light pt-2 pl-3 pb-3">
                    <div class="row m-0 p-0 position-relative">
                      <div class="mb-2"
                        *ngIf="(assignmentItem.opportunityServiceId == '' || assignmentItem.opportunityServiceId == undefined)">
                        Opportunity: <span class="font-weight-bold">—</span>
                      </div>
                      <div class="mb-2"
                        *ngIf="(assignmentItem.opportunityServiceId != '' && assignmentItem.opportunityServiceId != undefined)">
                        Opportunity: <span class="font-weight-bold">{{assignmentItem.opportunityName}}
                          ({{assignmentItem.opportunityServiceId}})</span>
                      </div>
                      <div class="row m-0 p-0 pb-4">
                        <div class="col-xl-3 col-md-6 pl-0">
                          <p class="position-absolute"><strong>{{assignmentItem?.assignmentName}}&nbsp;</strong>
                            <span *ngIf="engagementList.clientCode!=null">- {{engagementList?.clientCode}}</span>
                            <span *ngIf="assignmentItem.assignmentCode!=null">.{{assignmentItem?.assignmentCode}}</span>
                            <span *ngIf="assignmentItem.isPrimaryAssignment"> - Primary</span>
                          </p>
                        </div>
                      </div>
                      <div class="position-absolute ediControls">
                        <a id="editAssignmentLink" (click)="editAssignment(assignmentItem)">
                          <span class="align-middle mr-1">Edit</span>
                          <img class="btnEditRemove"
                            src="../../../../assets/images/EDP/Engagement/edit-24px.svg" alt="Edit">
                        </a>
                        <a id="removeAssignmentLink"
                          (click)="removeAssignment(assignmentItem)">
                          <span class="align-middle mr-1">Remove</span>
                          <img class="btnEditRemove"
                            src="../../../../assets/images/EDP/Engagement/remove_circle_outline-24px.svg" alt="Remove">
                        </a>
                      </div>
                      <div class="row m-0 p-0">
                        <div class="col-xl-3 col-md-6 pl-0">
                          <div class="mb-1">{{assignmentItem?.selectedengagementType?.value}}</div>
                          <div class="mb-1">{{assignmentItem?.selectedsolutionCode?.solutionCode}} -
                            {{assignmentItem?.selectedsolutionCode?.solutionCodeDescription}}</div>
                          <div class="mb-1">Estimated start date:
                            {{assignmentItem?.engagementStartDate | date: "MM/dd/yyyy"}}
                          </div>
                          <!-- start of Dayshapelink field -->
                          <div class="mb-1">
                            <a [href]="assignmentItem.dayShapeLink ? getDayShapeLink(assignmentItem.dayShapeLink) : null"
                              target="_blank" rel="noopener noreferrer" class="underline-link"
                              [class.disabled]="!assignmentItem.dayShapeLink?.trim()">
                              Staffing and resourcing
                            </a>
                          </div>
                          <!-- end of Dayshapelink field -->
                        </div>
                        <div class="col-xl-3 col-md-6">
                          <div class="mb-1">CMS PPMD:&nbsp;
                            <span id="cmsEPPMDContactPopup_{{assignmentItem.assignmentCodeId}}"
                              class="link-text-blue cms-eppmd-contact-popover"
                              (mousedown)="displayCMSEPPMDContactPopup(assignmentItem)">{{assignmentItem?.cmsEPPMDName}}</span>
                          </div>
                          <div class="mb-1">Assignment administrator:&nbsp;
                            <span id="adminContactPopup_{{assignmentItem.assignmentCodeId}}"
                              class="link-text-blue admin-contact-popover"
                              (mousedown)="displayAdminContactPopup(assignmentItem)">{{assignmentItem?.assignmentAdministrator}}</span>
                          </div>
                          <div class="mb-1">Estimated end date: {{assignmentItem?.engagementEndDate | date: "MM/dd/yyyy"}}
                          </div>
                        </div>
                        <div class="col-xl-3 col-md-6 pl-0">
                          <div class="mb-1">Realization %: <strong>{{assignmentItem?.realization}}%</strong></div>
                          <div class="mb-1">Estimated net fees: <strong>{{assignmentItem?.netFeesInCurrencyFormat
                              }}</strong>
                          </div>
                          <div class="mb-1">Billing contact:
                            <span class="font-weight-bold"
                              *ngIf="assignmentItem.clientBillingContactName!='' && assignmentItem.clientBillingContactTitle!=''">
                              {{assignmentItem?.clientBillingContactName}},
                              {{assignmentItem?.clientBillingContactTitle}}
                            </span>
                          </div>
                          <div class="mb-1">Billing contact email:
                            <span class="font-weight-bold" style="word-break: break-all;"
                              *ngIf="assignmentItem.clientBillingContactEmail!='' && assignmentItem.clientBillingContactEmail!=null">
                              {{assignmentItem?.clientBillingContactEmail}}
                            </span>
                          </div>
                        </div>
                        <div class="col-xl-3 col-md-6">
                          <div class="mb-1" *ngIf="assignmentItem.isContingent">Contingent: <strong>Yes</strong></div>
                          <div class="mb-1" *ngIf="!assignmentItem.isContingent">Contingent: <strong>No</strong></div>
                          <div class="mb-1">Estimated gross margin %:
                            <strong>{{assignmentItem?.estimatedGrossMargin}}%</strong>
                          </div>
                          <div class="mb-1">Closest GT office: <strong>{{assignmentItem?.officeLocationCodeName}}</strong>
                          </div>
                          <div class="mb-1">
                            Assignment EQCR:&nbsp;
                            <span class="link-text-blue contactUser cursor-pointer"
                              id="eqcrNameContactPopup_{{assignmentItem.assignmentCodeId}}"
                              (mousedown)="displayEQCRContactPopup(assignmentItem)" *ngIf="!assignmentItem.isEditEQCR">
                              {{assignmentItem?.eqcrName}}
                            </span>
                            &nbsp;

                            <div class="px-0 my-1" *ngIf="assignmentItem.isEditEQCR">
                              <div class="d-flex align-items-center">
                                <div class="input-group mw-100 w-46-sm w-75">
                                  <app-people-picker class="eng-assign-people-picker" [IsPickerForAssignment]=true
                                    [roleShortName]="EQCRRoleName" [labelCtrlName]="EQCRlblCtrlName" [isLabelVisible]="false"
                                    [InputCtrlIdIndex]="i" [PeoplePickerModel]="assignmentItem.newEQCRName"
                                    [userEmail]="assignmentItem.newEQCREmailId" [IsValidateUserWithADGroup]="validateEQCR">
                                  </app-people-picker>
                                  <div class="input-group-append input-height">
                                    <button type="button" id="PPIcon_{{i}}" data-toggle="modal" data-target="#modal-AssignmentEQCR"
                                      data-keyboard="false" data-backdrop="static" class="mw-100 people-picker-button text-center"
                                      (click)="refreshAssignmentEQCRPopup(i,'txtPeoplePicker_')">
                                      <img src="assets/images/EDP/LeftSidebar/picker.svg" alt="Assignment EQCR" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div style="text-align: right;" class="w-75">
                                <span class="ml-4 cursor-pointer link-text-blue" (click)="cancelEQCR(i)">Cancel</span>
                                <span class="ml-4 font-weight-bold  link-text-blue"
                                  (click)="updateEngagementEQCR(i, assignmentItem.assignmentCodeId)">Save</span>
                              </div>
                              <div class="form-control-feedback error-color" *ngIf="!assignmentItem.isvalidEQCR">
                                <p>Assignment EQCR should be valid</p>
                              </div>
                              <div id="businessMessageForEQCRDiv" *ngIf="!assignmentItem.isValidEQCRBusinessRule"
                                class="form-control-feedback error-color">
                                <p>EQCR cannot be EPPMD or CMS PPMD or AA</p>
                              </div>
                              <div id="businessMessageForEQCRDiv" *ngIf="assignmentItem.isEQCRExists"
                                class="form-control-feedback error-color">
                                <p>No change in EQCR to save</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End readonly assignment view -->
            </div>
            <!-- End assignment details -->
        </div>
        <!-- End assignment-radio-container -->
      </div>
    </div>
    <!-- End col-md-12 p-0 -->
  </div>
  <!-- End row m-0 mt-3 -->

  <div class="form-control-feedback error-color" *ngIf="isAssignmentSelected">
    <span>Atleast one assignment must be selected.</span>
  </div>
  <!-- </div> -->
  <!-- End col-md-12 m-0 pl-0 -->
</div>
<!-- End row m-0 mt-4 -->
<!-- End col-md-12 m-0 pl-0 -->
<!-- </div> -->
<!-- End row m-0 mt-4 -->


  <div id="engagementDetailHeaderDiv" class="row col-md-12 mt-4">
    <h6 class="form-heading-text">Change order template</h6>
  </div>
  <div class="col-md-12 bg-white pl-0 pr-0 pb-3">
    <div class="row">
      <div class="col-xl-6 col-md-6 pr-0 pt-3">
        <label><span class="label">Select change order template </span> <span class="label mandatory">*</span></label>
        <div class="selectdiv ">
          <select *ngIf="!editMode" id="drpchangeOrderTemplate" name="ChangeOrderTemplate" class="dropdown rounded-0"
            [(ngModel)]="selectedChangeOrderTemplate">
            <option value="-1">Select...</option>
            <option *ngFor="let template of SelectedTemplateList" [value]="template.templatePackageId">
              {{ template.templateName }}
            </option>
          </select>
          <select *ngIf="editMode" id="drpchangeOrderTemplate" name="ChangeOrderTemplate" class="dropdown rounded-0"
            [(ngModel)]="selectedChangeOrderTemplate">
            <option value="-1">Select...</option>
            <option *ngFor="let template of SelectedTemplateList" [value]="template.templatePackageId">
              {{ template.templateName }}
            </option>
          </select>
        </div>
        <div class="form-control-feedback error-color" *ngIf="!isChangeorderTemplateSelected">
          <span>Change order template is a required field.</span>
        </div>
      </div>
    </div>
    <div>
      <div class="row col-md-12 mt-4">
        <h6 class="form-heading-text">Team members</h6>
      </div>
      <span class="d-inline-block align-middle msg-text">
        If this change order requires additional team members, add them in <a class="eng-pointer-cursor" (click)="onManageTeamLinkClicked()"
          target="_blank">"Manage team" </a> for this engagement.
      </span>
      <!-- OLD code to add team member -->
      <!-- <div class="col-md-6 mw-100 pl-0">
        <div id="divAddNewTeamMember" *ngIf="uiTeamMemberList.length > 0" class="row ml-0">
          <div id="tblTeamMember" aria-describedby="Team members" class="w-100">
            <div *ngFor="let teamMember of uiTeamMemberList;let i = index" id="clientUserListContainer"
              class="teammemberDataRow row mx-0 pb-3 bg-white" style="justify-content: space-around;">
              <div class="col-xl-4 col-md-11 mt-3 mlm-2">
                <div class="input-group mx-100">
                  <app-people-picker class="eng-people-picker" [roleShortName]="teamMemberRoleName"
                    [labelCtrlName]="teamMemberlblCtrlName" [isLabelVisible]="false" [InputCtrlIdIndex]="i"
                    [PeoplePickerModel]="teamMember.memberName" [userEmail]="teamMember.memberEmailId"
                    [IsValidateUserWithADGroup]="validateTM[i]">
                  </app-people-picker>

                  <div class="input-group-append input-height">
                    <button type="button" id="PPIcon_{{peoplepickerIndex}}" data-toggle="modal"
                      data-target="#modal-TeamMember" data-keyboard="false" data-backdrop="static"
                      class="mw-100 people-picker-button text-center"
                      (click)="refreshTeamMemberPopup(i,'txtPeoplePicker_')">
                      <img src="assets/images/EDP/LeftSidebar/picker.svg" alt="Team Member" />
                    </button>
                  </div>
                </div>
                <div>
                  <span id="errorLabelMemberName{{i}}" class="label error-color "
                    *ngIf="this.arrValidationForNewTeamMember[i].memberName==null ||this.arrValidationForNewTeamMember[i].memberName==''"
                    style="display:none;">Select team member name</span>
                  <span id="userExist{{i}}" class="label error-color"
                    *ngIf="(this.arrValidationForNewTeamMember[i].isNewUserDuplicate || this.arrValidationForNewTeamMember[i].isUserExist ) && this.arrValidationForNewTeamMember[i].memberName !=null && this.arrValidationForNewTeamMember[i].memberName != ''">User
                    already exists!</span>
                  <span class="label error-color"
                    *ngIf="!this.arrValidationForNewTeamMember[i].ishdnValidInputName && this.arrValidationForNewTeamMember[i].memberName !=null && this.arrValidationForNewTeamMember[i].memberName != '' ">
                    Team member should be valid</span>
                </div>
              </div>

              <span class="devider px-0 text-center hide-me"></span>

              <div class="col-xl-3 col-md-5 mt-3">

                <div *ngIf="isUserAgentIE < 0" class="selectdiv">
                  <select *ngIf="isAudit; else isTeamMember" id="drpKeyTeamMemberRole_{{i}}" required
                    name="KeyTeamMemberRole_{{i}}" class="form-control dropdown rounded-0"
                    [(ngModel)]="teamMember.teamMemberRole" (change)="OnKeyRoleChange($event,i)">
                    <option value="null">Select role</option>
                    <option id="drpKeyTeamMembersOptions_{{i}}" *ngIf="teamMember.teamMemberRole==eppmdRoleIdAppMaster"
                      [value]=eppmdRoleIdAppMaster selected>Engagement
                      PPMD</option>
                    <option id="drpKeyTeamMembersOptions_{{i}}" *ngFor="let role of keyteamMemberRoleFromAppMstList"
                      [value]=role.applicationMasterId>
                      {{role.value}}
                    </option>
                  </select>
                  <ng-template #isTeamMember>
                    <select id="drpTeamMemberRole_{{i}}" required name="TeamMemberRole_{{i}}"
                      class="form-control dropdown rounded-0" (change)="OnRoleChange($event,i)"
                      [(ngModel)]="teamMember.teamMemberRole"
                      [disabled]="teamMember.teamMemberRole == eppmdRoleIdAppMaster">
                      <option value="null" disabled hidden>Select role</option>
                      <option id="drpTeamMembersOptions_{{i}}" *ngIf="teamMember.teamMemberRole==eppmdRoleIdAppMaster"
                        [value]=eppmdRoleIdAppMaster selected>Engagement
                        PPMD</option>
                      <option id="drpTeamMembersOptions_{{i}}" *ngFor="let role of teamMemberRoleFromAppMstList"
                        [value]=role.applicationMasterId selected>
                        {{role.value}}
                      </option>
                    </select>
                  </ng-template>
                </div>
                <div *ngIf="isUserAgentIE > 0" class="selectdiv">
                  <select id="drpTeamMemberRole_{{i}}" required name="TeamMemberRole_{{i}}"
                    class="form-control dropdown rounded-0" (change)="OnRoleChange($event,i)"
                    [(ngModel)]="teamMember.teamMemberRole">
                    <option value="" disabled hidden>Select role</option>
                    <option id="drpTeamMembersOptions_{{i}}" *ngFor="let role of applicationmasterListIE"
                      [value]=role.applicationMasterId>
                      {{role.value}}
                    </option>
                  </select>
                </div>
                <div>
                  <span id="errorLabelMemberRole{{i}}" class="label error-color d-none">
                    Select team member role</span>
                </div>
              </div>

              <span class="devider px-0 text-center hide-me"></span>

              <div class="col-xl-3 col-md-6 mt-3 mr-4">
                <div class="selectdiv ">
                  <select *ngIf="editMode" id="drpTeamMemberPermissions_{{i}}" name="TeamMemberPermission_{{i}}"
                    class="form-control dropdown rounded-0" [(ngModel)]="teamMember.teamMemberPermissionId">
                    <option value="-1">Select permissions</option>
                    <option id="drpTeamMemberPermissionsOptions_{{i}}" *ngFor="let permission of teamMemberPermissions"
                      [value]=permission.id>
                      {{permission.typeValue}}
                    </option>
                  </select>

                  <select *ngIf="!editMode" id="drpTeamMemberPermissions_{{i}}" name="TeamMemberPermission_{{i}}"
                    class="form-control dropdown rounded-0">
                    <option value="-1">Select permissions</option>
                    <option id="drpTeamMemberPermissionsOptions_{{i}}" *ngFor="let permission of teamMemberPermissions"
                      [value]=permission.id>
                      {{permission.typeValue}}
                    </option>
                  </select>
                </div>
                <div>
                  <span id="errorLabelMemberPermission{{i}}" class="label error-color d-none">
                    Select team member permission</span>
                </div>
              </div>
              <div class="pl-0 delRow mt-3" [ngClass]="{'ml-4':teamMember.teamMemberRole==eppmdRoleIdAppMaster}">
                <a *ngIf="teamMember.teamMemberRole!=eppmdRoleIdAppMaster" id="removeLink_{{i}}"
                  (click)="removeTeamMember(i,teamMemberRoleName)" style="line-height: 38px;">
                  <img src="assets/images/EDP/Engagement/remove_circle_outline.svg" alt="Remove Team Member">
                </a>
              </div>
              <div class="col-xl-5"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mx-0 py-2">
        <div class="col-md-3 mw-100 pl-0">
          <div class="bg-white">
            <button class="btn add-teammember-button" type="button" id="addGTTeamMemberCo" (click)="addTeamMember()">
              <img src="assets/images/EDP/Engagement/add_box-blue.svg" alt="Add new team member(s)">
              <span class="d-inline-block pl-2"> Add team member </span>
            </button>
          </div>
        </div>
      </div> -->
      <!-- OLD code to add team member -->
    </div>
    <div class="row m-0">&nbsp;</div>
    <div class="row m-0 text-right">
      <div class="col-xl-3 hide-me">&nbsp;</div>
      <div class="col-xl-3 col-md-4 pl-0"></div>
      <div class="col-xl-3 col-md-4">
        <button class="btn SecondaryButton w-100 text-center" type="button" (click)="setCancelDialog()">
          <span class="d-inline-block align-middle"> Cancel</span>
        </button>
      </div>
      <div class="col-xl-3 col-md-4">
        <button *ngIf="!editMode" class="btn PrimaryButton w-100 text-center" id="btnNext" type="button"
          (click)="onCreateChangeOrderClicked()">
          Create change order
          <img class="d-inline-block ml-1" src="../../../assets/images/icons/arrow_forward.svg"
            style="cursor: pointer; margin-bottom: 3px; width: 18px; height: 18px;" alt="Next" />
        </button>
        <button *ngIf="editMode" class="btn PrimaryButton w-100 text-center" id="btnNext" type="button"
          (click)="onUpdateChangeOrderClicked()">
          Update change order
          <img class="d-inline-block ml-1" src="../../../assets/images/icons/arrow_forward.svg"
            style="cursor: pointer; margin-bottom: 3px; width: 18px; height: 18px;" alt="Next" />
        </button>
      </div>
    </div>

    <div class="row m-0 pt-4">
      <div class="col-md-12 px-0">
        <app-alerts></app-alerts>
      </div>
    </div>

    <!-- add team memmber popup Start -->

    <div id="modal-TeamMember" class="modal fade modal-window" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span class="modal-title">Select team member</span>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="deselectTeamMember();">
              <span class="close-text mr-1">Close </span>
              <span class="modal-close-btn">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <span id="TeamMemberErrorMessage" class="ErrorFont"></span>
            <div class="input-group nav-searchbox-length pb-2">
              <input type="text" id="searchTeamMemberName"
                (keydown.enter)="searchUsers('searchTeamMemberName','tblMemberAD');"
                class="form-control py-1 rounded-0 nav-seachBox" placeholder="Search for team member"
                autocomplete="off">
              <span class="input-group-append nav-seachBox">
                <div class="input-group-text" (click)="searchUsers('searchTeamMemberName','tblMemberAD');">

                  <img src="../../../assets/images/EDP/Filters/search.svg" alt="Search" class="nav-searchIcon" />
                </div>
              </span>
            </div>
            <span class="span-hint mt-1">Hint: Last name, first name, or email.</span>
            <div class="tableScroll mt-2">
              <table id="tblMemberAD" class="table  table-hover" aria-describedby="Members">
                <thead>
                  <tr>
                    <th scope="col"> Name</th>
                    <th scope="col"> Email </th>
                    <th scope="col">Job Title</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Line of Business</th>
                    <th scope="col">Service Line</th>
                    <th scope="col">Location</th>
                  </tr>
                </thead>
                <tbody>
                  <tr id="trTeamMembers" name="trTeamMembers"
                    *ngFor="let member of membersListArrayForTeamMembers let i=index"
                    (click)='selectTeamMember(i,member)'>
                    <td id="TeamMemberList{{i}}">
                      <span id='spMemberdisplayName{{i}}'>{{member.displayName}}</span>
                    </td>
                    <td id="TeamMemberList{{i}}"> <span id='spMembermail{{i}}'>{{member.mail}}</span>
                    </td>
                    <td>
                      <span id='spjobtitle{{i}}'>{{member.jobTitle}}</span>
                    </td>
                    <td id="TeamMemberList{{i}}"> <span
                        id='spMemberbusinessPhones{{i}}'>{{member.businessPhones}}</span>
                    </td>
                    <td> <span id='splineOfBusiness{{i}}'>{{member.lineOfBusiness}}</span>
                    </td>
                    <td> <span id='spserviceLine{{i}}'>{{member.serviceLine}}</span>
                    </td>
                    <td> <span id='splocation{{i}}'>{{member.location}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="SecondaryButton" style="width: 150px; text-align: center;" data-dismiss="modal"
              (click)="deselectTeamMember();">
              <span class="d-inline-block mr-1 align-top">
                <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/cancel-blue.svg">
              </span>
              <span class="d-inline-block align-middle">Cancel</span>
            </button>
            <button type="button" class="PrimaryButton" style="width: 150px; text-align: center;" data-dismiss="modal"
              (click)="setTeamMember();">
              <span class="d-inline-block mr-1 align-top">
                <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/delete-white.svg">
              </span>
              <span class="d-inline-block align-middle">OK</span>
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- add team memmber popup End -->


</div>

<div class="changeOrderAssignmentComponent">
<app-change-order-assignment-opportunity-popup
  [isOpen]="isModalOpen"
  [selectedChangeOrderClient]="selectedChangeOrderClient"
  [assignments]="engagementAssignmentList"
  [opportunityList]="opportunityList"
  [accountId]="accountId"
  (closeModal)="closeModal()"
  [interchangeableSolutionCodesList]="interchangeableSolutionCodes"
  (confirmSelection)="onAssignmentSelectionConfirm($event)">
</app-change-order-assignment-opportunity-popup>
</div>